export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-buttons@2x-cab81753abe9d4d64897157837b38060.png";